// import React, { useEffect, useState } from 'react'
// import { Navbar, Container, Form, InputGroup, Image } from 'react-bootstrap'
// import { Bell, ChatSquareDots } from 'react-bootstrap-icons'
// import tmslogo from '../TmsImages/Kaas_logo.jpg'
// import axios from 'axios'

// const TmsHeader = () => {
//   const [username, setUsername] = useState('')

//   useEffect(() => {
//     const token = localStorage.getItem('jwttoken')
//     const URL = 'https://kaasbackend.vetrinahealthcare.com/'

//     axios
//       .get(`${URL}lms/user/`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         setUsername(response.data.first_name)
//       })
//   }, [])

//   return (
//   <Navbar expand="lg" bg="white" className="py-2 shadow-sm" style={{ position: 'relative', height: '70px' }}>
//     <Container fluid className="h-100">
//       {/* Logo on the left */}
//       <div className="d-flex align-items-center h-100">
//         <Image
//           src={tmslogo}
//           alt="Logo"
//           width="150"
//           height="50"
//           className="me-2"
//         />
//       </div>

//       {/* Centered Title */}
//       <div
//         className="position-absolute start-50 top-50 translate-middle"
//         style={{
//           whiteSpace: 'nowrap'
//         }}
//       >
//         <span className="fw-bold fs-4 text-center">
//           Training Management System
//         </span>
//       </div>

//       {/* Icons and Username on the right */}
//       <div className="d-flex align-items-center ms-auto h-100">
//         <div className="position-relative me-3">
//           <Bell size={24} className="text-danger" />
//           <span
//             className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
//             style={{
//               fontSize: '0.75rem',
//               padding: '0.25em 0.5em',
//             }}
//           >
//             1
//           </span>
//         </div>
//         <div className="position-relative me-3">
//           <ChatSquareDots size={24} className="text-danger" />
//           <span
//             className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
//             style={{
//               fontSize: '0.75rem',
//               padding: '0.25em 0.5em',
//             }}
//           >
//             1
//           </span>
//         </div>
//         <span className="fw-semibold">{username}</span>
//       </div>
//     </Container>
//   </Navbar>
// );

// }

// export default TmsHeader

import React, { useEffect, useState } from 'react';
import { Navbar, Container, Image } from 'react-bootstrap';
import { Bell, ChatSquareDots } from 'react-bootstrap-icons';
import tmslogo from '../TmsImages/Kaas_logo.jpg'
import axios from 'axios';

const TmsHeader = () => {
  const [username, setUsername] = useState("");
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const [unreadMessages, setUnreadMessages] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("jwttoken");
    const URL = "https://kaasbackend.vetrinahealthcare.com";

    // Fetch username
    axios
      .get(`${URL}/lms/user/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setUsername(response.data.first_name);
      });

    // Fetch notifications and messages
    const fetchCounts = () => {
      axios
        .get(`${URL}/lms/notifications/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setUnreadNotifications(response.data.unread_count);
        });

      axios
        .get(`${URL}/lms/messages/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setUnreadMessages(response.data.unread_count);
        });
    };

    fetchCounts();

    // Set interval for periodic updates
    const interval = setInterval(fetchCounts, 10000); // Fetch every 10 seconds

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <Navbar expand="lg" bg="white" className="py-2 shadow-sm">
      <Container fluid className="align-items-center">
        {/* Logo and Title */}
        <Navbar.Brand href="#" className="d-flex align-items-center">
          <Image src={tmslogo} alt="Logo" width="150" height="50" className="me-2" />
          <span className="fw-bold fs-4">Training Management System</span>
        </Navbar.Brand>

        {/* Icons */}
        <div className="d-flex align-items-center">
          <div className="position-relative me-3">
            <Bell size={24} className="text-danger" />
            {unreadNotifications > 0 && (
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{
                  fontSize: '0.75rem',
                  padding: '0.25em 0.5em',
                }}
              >
                {unreadNotifications}
              </span>
            )}
          </div>
          <div className="position-relative me-3">
            <ChatSquareDots size={24} className="text-danger" />
            {unreadMessages > 0 && (
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{
                  fontSize: '0.75rem',
                  padding: '0.25em 0.5em',
                }}
              >
                {unreadMessages}
              </span>
            )}
          </div>
          <span>{username}</span>
        </div>
      </Container>
    </Navbar>
  );
};

export default TmsHeader;
